import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[inputfield]',
    standalone: false,
})
export class InputFieldDirective {
    constructor(public el: ElementRef) { }
}